import { Component, input } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "new-ui-dashboard-card-header",
  templateUrl: "./new-ui-dashboard-card-header.component.html",
  imports: [RouterLink],
})
export class NewUiDashboardCardHeaderComponent {
  readonly title = input<string>();

  readonly routerLink = input<string>(null);
}
